import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import {chain, SetShipToForEditing } from "@insite/client-framework/Store/Pages/CheckoutShipping/Handlers/SetUseOneTimeAddress";
import cloneDeep from "lodash/cloneDeep";
import { getCurrentCountries } from "@insite/client-framework/Store/Data/Countries/CountriesSelectors";
import { ShipToModel } from "@insite/client-framework/Types/ApiModels";

replaceInChain(chain, SetShipToForEditing, props => {
        const {
            getState,
            parameter: { useOneTimeAddress },
            cart,
            shipTosForBillTo,
        } = props;
        const state = getState();
    
        if (useOneTimeAddress) {
            const shipTo = shipTosForBillTo.find(o => o.oneTimeAddress);
            if (!shipTo) {
                throw new Error("The one-time address shipto was not found in the cart. It must be loaded with the cart.");
            }
    
            props.shipToForEditing = {
                ...cloneDeep(shipTo),
                firstName: "",
                lastName: "",
                attention: "",
                companyName: "",
                address1: "",
                address2: "",
                address3: "",
                address4: "",
                city: "",
                state: null,
                postalCode: "",
                phone: "",
                email: "",
                fax: "",
            };
    
            const countries = getCurrentCountries(state);
            if (!countries) {
                throw new Error("There were no countries loaded yet");
            }
    
            props.shipToForEditing.country = countries.length === 1 ? countries[0] : null;
        } else {
            const {
                pages: {
                    checkoutShipping: { lastSelectedShippingAddress },
                },
            } = getState();
            let shipTo: ShipToModel | undefined = lastSelectedShippingAddress ;

            //login ship to is assigned if lastSelectedShippingAddress is empty. line 55 to 62 included in the existing chain
            let billToShipTo = shipTosForBillTo.find(o => !o.oneTimeAddress);
            if (billToShipTo !== undefined) {
                let loginShipTo: ShipToModel = billToShipTo;
                if(Object.keys(lastSelectedShippingAddress).length ===0)
                {
                    shipTo = loginShipTo;
                }
            } 
            
            if (shipTo.id === cart.billToId) {
                shipTo = shipTosForBillTo.find(o => o.isDefault);
                if (!shipTo) {
                    shipTo = shipTosForBillTo.find(o => !o.isNew && !o.oneTimeAddress && o.id !== cart.billToId);
                }
                if (!shipTo) {
                    throw new Error(
                        "No applicable shipto (e.g. one-time, billto) was found in the cart. At least one shipto must be available to allow editing.",
                    );
                }
            }
    
            props.shipToForEditing = shipTo;
        }
    
})

